import {$generateHtmlFromNodes} from '@lexical/html';
import {BaseSelection, LexicalEditor} from 'lexical';

import {getSafely} from 'shared/web';

const HTML_ENTITIES: Record<string, string> = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&#x2F;': '/',
  '&#x60;': '`',
  '&#x3D;': '=',
};

const HTML_ENTITY_REGEX = /&amp;|&lt;|&gt;|&quot;|&#39;|&#x2F;|&#x60;|&#x3D;/g;

export function $serializeEditorHtml(editor: LexicalEditor, selection?: BaseSelection) {
  return $generateHtmlFromNodes(editor, selection ?? null).replace(
    HTML_ENTITY_REGEX,
    (match) => getSafely(HTML_ENTITIES, match) ?? match
  );
}
